module.exports = __webpack_public_path__ + "img/download-android.2bf99e28.webp";